import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../api/axiosInstance";
import { API_URLS } from "../../api/apiUrls";

// --------------- Async Thunk---------

export const fetchAllLicenses = createAsyncThunk(
  "license/fetchAllLicenses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(API_URLS.GET_ALL_LICENSES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to fetch licenses");
    }
  },
);

//---------------GET LICENSE CUSTOMERS-------------
export const fetchAllLicenseCustomers = createAsyncThunk(
  "license/fetchAllLicenseCustomers",
  async (
    { pageNo = 1, limit = 10, sort = "-createdAt", search = "" } = {},
    { rejectWithValue },
  ) => {
    try {
      const url = API_URLS.GET_ALL_CUSTOMER(pageNo, limit, sort, search);
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch license customers",
      );
    }
  },
);

/*
|--------------------------------------------------------------------------
| Initial State
|--------------------------------------------------------------------------
*/

const initialState = {
  licenses: null,
  customers: [],
  totalCustomers: 0,
  limit: 10,
  skip: 0,
  loading: false,
  loadingLicenseCustomers: false,
  error: null,
};

/*
|--------------------------------------------------------------------------
| Slice
|--------------------------------------------------------------------------
*/

const licenseSlice = createSlice({
  name: "license",
  initialState,
  reducers: {
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchAllLicenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchAllLicenses.fulfilled, (state, action) => {
        state.loading = false;
        state.licenses = action.payload;
      })

      .addCase(fetchAllLicenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      //---fetchAllLicenseCustomers--------
      .addCase(fetchAllLicenseCustomers.pending, (state) => {
        state.loadingLicenseCustomers = true;
        state.error = null;
      })

      .addCase(fetchAllLicenseCustomers.fulfilled, (state, action) => {
        state.loadingLicenseCustomers = false;
        state.customers = action.payload?.data ?? [];
        state.totalCustomers = action.payload?.total ?? 0;
        state.limit = action.payload?.limit ?? state.limit;
        state.skip = action.payload?.skip ?? 0;
      })

      .addCase(fetchAllLicenseCustomers.rejected, (state, action) => {
        state.loadingLicenseCustomers = false;
        state.error = action.payload;
        state.customers = [];
      })
     
  },
});

export default licenseSlice.reducer;
